import * as React from 'react';

import { DatesChipContainer } from '../containers/DatesChipContainer';
import { FiltersChipContainer } from '../containers/FiltersChipContainer/FiltersChipContainer';
import { GuestsChipContainer } from '../containers/GuestsChipContainer';
import { OfferTypeChipContainer } from '../containers/OfferTypeChipContainer';
import { PriceChipContainer } from '../containers/PriceChipContainer';
import { RegionChipContainer } from '../containers/RegionChipContainer';
import { StarRatingChipContainer } from '../containers/StarRatingChipContainer';
import { EMobileFilters } from '../types/filters';

export const FILTER_COMPONENTS: Record<EMobileFilters, () => React.JSX.Element> = {
  [EMobileFilters.moreFilters]: FiltersChipContainer,
  [EMobileFilters.region]: RegionChipContainer,
  [EMobileFilters.dates]: DatesChipContainer,
  [EMobileFilters.guests]: GuestsChipContainer,
  [EMobileFilters.price]: PriceChipContainer,
  [EMobileFilters.starRating]: StarRatingChipContainer,
  [EMobileFilters.offerType]: OfferTypeChipContainer,
};
